import { Component, ViewChild, OnInit } from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';

import * as $ from "jquery";

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})




export class BlogComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;

 constructor(){}

 ngOnInit(){

 	jQuery(function($){

 			let owl = $('.owl-carousel');
      let blog = $('#blog');

		 	owl.owlCarousel({
		    margin:10,
		    touchDrag:true,
		    responsive:{
		        0:{
		            items:1
		        },
		        600:{
		            items:3
		        },
		        1000:{
		            items:5
		        }
		    }
		});

		$('.customNextBtn').click(function() {
		    owl.trigger('next.owl.carousel');
		});

		$('.customPrevBtn').click(function() {
		    owl.trigger('prev.owl.carousel');
		});

    $('.close_btn').click(function() {
        blog.css('display', 'none');
        ;
    });

	});

  }


}
